import { useState, useEffect } from 'react';
import './backToTopBtn.css';

export default function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    visible && (
      <button
        className="topBtn hybridBtn"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <img
          src="/assets/images/misc-stuff/backtotop.png"
          alt=""
          className="pixelArrow"
        />
        <span className="hoverText">BACK TO TOP</span>
      </button>
    )
  );
}
